import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-gradient-to-b from-warmWhite to-cream overflow-hidden" data-id="element-103">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-terracotta-200 opacity-50" data-id="element-104">
        <MoonIcon className="w-16 h-16" data-id="element-105" />
      </div>
      <div className="absolute top-20 right-20 text-sage-200 opacity-40" data-id="element-106">
        <SparklesIcon className="w-10 h-10" data-id="element-107" />
      </div>
      <div className="absolute bottom-40 left-20 text-terracotta-100 opacity-30" data-id="element-108">
        <SparklesIcon className="w-8 h-8" data-id="element-109" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20" data-id="element-110">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-111">
          {/* Text Content */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-112">
            <p className="text-sage font-medium text-sm tracking-widest uppercase mb-4" data-id="element-113">
              Luna Dulce presenta
            </p>

            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-charcoal leading-tight mb-6" data-id="element-114">
              Manual de Supervivencia:{' '}
              <span className="text-terracotta italic" data-id="element-115">
                Sueño del Recién Nacido
              </span>
            </h1>

            <h2 className="font-body text-xl sm:text-2xl text-warmGray leading-relaxed mb-8 max-w-2xl" data-id="element-116">
              Logra que tu bebé duerma y tu recuperes la tranquilidad en los
              próximos 3 días
            </h2>

            <motion.a href="https://www.aky.com.co/cart/45243803140287:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracotta text-white font-semibold text-lg px-8 py-4 rounded-full shadow-warm-lg hover:shadow-xl transition-shadow" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} data-id="element-117">
              ¡QUIERO DORMIR POR FIN! – DESCARGAR AHORA
            </motion.a>

            <p className="mt-4 text-warmGray text-sm" data-id="element-118">
              Acceso inmediato tras el pago. Tu descanso empieza esta noche.
            </p>
          </motion.div>

          {/* Product Image */}
          <motion.div className="flex-1 flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-119">
            <div className="relative" data-id="element-120">
              <div className="absolute -inset-4 bg-gradient-to-br from-terracotta-100 to-sage-100 rounded-3xl opacity-50 blur-2xl" data-id="element-121" />
              <img src="https://cdn.magicpatterns.com/uploads/1d6G7WepzJuKKYfd3Eu68B/E-book_Sueno_del_recien_nacido.png" alt="Manual de Supervivencia: Sueño del Recién Nacido - Guía completa mostrada en laptop, tablet y móvil" className="relative w-full max-w-lg rounded-2xl shadow-warm-lg" data-id="element-122" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}